import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Flex, Box, Copy, Icon, Hide } from '@elparking/components'
import PlacesSelect from 'vehicle-inspection-station-search-map/js/ui/PlacesSelect'
import VehicleInspectionSelector from 'commons/js/components/VehicleInspectionTypeSelector'

import {
    PlaceSelectorContainer,
    SeparatorBox,
    VehicleTypeSelectorContainer,
    VehicleTypeContainer,
} from './ui/layout'
import { ITV_VEHICLE_FILTERS } from 'commons/js/constants'

import {
    placesAutocomplete,
    mapPlacePredictionWithType,
} from 'commons/js/services/autocompleteService'

import messages from './messages'
import { Events, trackEvent } from 'commons/js/services/analytics'

class SearchForm extends React.PureComponent {
    renderPlacesSelectOption = this.renderPlacesSelectOption.bind(this)
    onChangeVehicleFilter = this.onChangeVehicleFilter.bind(this)
    onChangePlace = this.onChangePlace.bind(this)

    onChangeVehicleFilter ({ value }) {
        const { place, trackEvent } = this.props
        trackEvent(Events.vehicleInspectionSearchChangeVehicleType, value)
        this.props.onSearch({ place, vehicleFilter: value })
    }

    onChangePlace ({ label, value }) {
        const { vehicleFilter, trackEvent } = this.props
        trackEvent(Events.vehicleInspectionSearchChangePlace, label)
        this.props.onSearch({ place: {name: label, place_id: value}, vehicleFilter })
    }

    renderPlacesSelect () {
        const { intl, showGoogleBanner } = this.props
        const { place } = this.props
        const placeholder = intl.formatMessage(messages.placePlaceholder)
        const value = mapPlacePredictionWithType(place).value
        return (
            <PlacesSelect
              showGoogleBanner={showGoogleBanner}
              value={place.name && value && {label: place.name, value}}
              placeholder={placeholder}
              autocompleteService={placesAutocomplete}
              onChange={this.onChangePlace}
              optionRenderer={this.renderPlacesSelectOption}
            />
        )
    }

    renderPlacesSelectOption ({ label }) {
        return (
            <Flex alignItems='center'>
                <Icon type='location' color='gray' align='baseline' /> <Box pl='0.5em'>{label}</Box>
            </Flex>
        )
    }

    render () {
        return (
            <Flex w='100%' flexWrap={['wrap', 'nowrap']}>
                <Hide xs sm md w='100%'>
                    <PlaceSelectorContainer w='100%' flex='1' flexWrap='nowrap'>
                        <Flex w='100%' flexWrap='wrap'>
                            <Flex width='49%' flexWrap='wrap'>
                                <Box w='100%' pl='0.8em' pt='0.5em'>
                                    <Copy as='span' color='gray60' fontWeight='medium' lineHeight='0' size='xxxSmall' transform='uppercase' padding='0'>
                                        {this.props.intl.formatMessage(messages.placeLabel)}
                                    </Copy>
                                </Box>
                                <Box w='100%'>
                                    {this.renderPlacesSelect()}
                                </Box>
                            </Flex>
                            <Box width='2%'>
                                <SeparatorBox />
                            </Box>
                            <Flex width='49%' flexWrap='wrap'>
                                <Box w='100%' pl='0.8em' pt='0.5em'>
                                    <Copy as='span' color='gray60' fontWeight='medium' lineHeight='0' size='xxxSmall' transform='uppercase' padding='0'>
                                        {this.props.intl.formatMessage(messages.vehicleTypeLabel)}
                                    </Copy>
                                </Box>
                                <Box w='100%'>
                                    <VehicleInspectionSelector
                                      width='100%'
                                      defaultValue={this.props.vehicleFilter}
                                      onChange={this.onChangeVehicleFilter}
                                      selectorElement={VehicleTypeSelectorContainer}
                                    />
                                </Box>
                            </Flex>
                        </Flex>
                    </PlaceSelectorContainer>
                </Hide>
                <Box flex='1' width='100%'>
                    <Hide lg>
                        <PlaceSelectorContainer w='100%' flex='1' flexWrap='nowrap'>
                            <Flex flex={['1', '0 1 50%']} flexWrap='wrap'>
                                <Box w='100%' pl='1em' pt='0.4em'>
                                    <Copy as='span' color='gray60' fontWeight='medium' lineHeight='0' size='xxxSmall' transform='uppercase'>
                                        {this.props.intl.formatMessage(messages.placeLabel)}
                                    </Copy>
                                </Box>
                                <Box w='100%'>
                                    {this.renderPlacesSelect()}
                                </Box>
                            </Flex>
                        </PlaceSelectorContainer>
                        <VehicleTypeContainer flex={['1', '0 1 50%']} flexWrap='wrap'>
                            <Box w='100%' pl='1em' pt='0.4em'>
                                <Copy as='span' color='gray60' fontWeight='medium' lineHeight='0' size='xxxSmall' transform='uppercase'>
                                    {this.props.intl.formatMessage(messages.vehicleTypeLabel)}
                                </Copy>
                            </Box>
                            <Box w='100%'>
                                <VehicleInspectionSelector
                                  defaultValue={this.props.vehicleFilter}
                                  onChange={this.onChangeVehicleFilter}
                                  selectorElement={VehicleTypeSelectorContainer}
                                />
                            </Box>
                        </VehicleTypeContainer>
                    </Hide>
                </Box>
            </Flex>
        )
    }
}

SearchForm.defaultProps = {
    place: {},
    onSearch: () => {},
    trackEvent,
}

SearchForm.propTypes = {
    intl: PropTypes.object,
    place: PropTypes.shape({
        name: PropTypes.string,
        place_id: PropTypes.string,
    }),
    vehicleFilter: PropTypes.oneOf(ITV_VEHICLE_FILTERS),
    showGoogleBanner: PropTypes.bool,
    onSearch: PropTypes.func,
    trackEvent: PropTypes.func,
}

export default injectIntl(SearchForm)
